import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import type { GetStaticProps } from "next";
import Head from "next/head";
import { Navbar } from "components/modules/Navigation/Navbar/Navbar";
import { Footer } from "components/modules/Layout/Footer/Footer";
import { BetaBanner } from "components/common/BetaBanner/BetaBanner";
import { commonLanguageFiles } from "client/config";
import { Translate } from "components/common/Translate/Translate";
import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { LanguageProvider } from "client/contexts/LanguageProvider";
import {TrustPilotSection} from "components/modules/TrustPilot/TrustPilotSection";
import React from "react";

const PrivacyPolicyPage = () => {
    return (
        <>
            <Head>
                <title>{`${capitalize(translateFunc("privacy-policy"))} | ImageResizer.com`}</title>
            </Head>
            <div className="max-w-1440 page-shadow text-black dark:text-white dark:bg-darkSurface-100">
                <Navbar url="/privacy" />
                <div className="py-8 mx-8 md:mx-24 lg:mx-44 flex flex-col gap-8 leading-relaxed">
                    <BetaBanner />
                    <h1 className="text-3xl font-semibold capitalize">
                        <Translate keyName="privacy-policy" />
                    </h1>
                    <div>
                        <Translate keyName="paragraph-1" />
                    </div>
                    <div>
                        <Translate keyName="paragraph-2" />
                    </div>
                    <div>
                        <Translate keyName="paragraph-3" />
                    </div>
                </div>
                <TrustPilotSection />
                <Footer url="/privacy" />
            </div>
        </>
    );
};

const files = ["privacy", ...commonLanguageFiles];

const LanguageWrapper = () => (
    <LanguageProvider files={files}>
        <PrivacyPolicyPage />
    </LanguageProvider>
);

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
    props: {
        ...(await serverSideTranslations(locale ?? "", files)),
    },
});

export default LanguageWrapper;
